import React, { useMemo, useState } from 'react'
import { useGlobalFilter, usePagination, useSortBy, useTable } from 'react-table'
import ComponentePaginacionTabla from 'components/Varios/Tabla/ComponentePaginacionTabla';
import { GlobalFilterTable } from 'components/Varios/Tabla/GlobalFilterTable';
import ButtonDownloadReportTable from "components/Varios/Tabla/ComponentButtonExcel"
import { Row, Col } from 'react-bootstrap';
import { ObtenerFechaFromIsoFormat } from 'functions/DatesFunctions';
import { Table } from 'reactstrap'
import { getTdTableStyles } from 'helpers/Table/tableFunctions';
import { CustomStyleColumn } from 'components/Types/GeneralTypes';

import PdfSVG from "assets/icons/Permisos/PDF(azul).svg"

export default function TablaHistorialProyectosInstitucionalesConsultor({ dataFilas, onClickVerDocumento, anioSeleccionado, onChangeAnio }) {

  const [anioMostrado, setanioMostrado] = useState(anioSeleccionado);

function GenerarCellAcciones(data) {
    const iconoVerDocumentoAutoridad = (
        data.acciones.refarchivorectorado ?
            <span style={{ cursor: 'pointer' }}>
                <i
                    data-toggle="tooltip" data-placement="top" title="Ver Documento - Designación"
                    onClick={() => onClickVerDocumento(data.acciones.refarchivorectorado)}
                >
                    <img
                        src={PdfSVG}
                        className="acciones"
                        alt="Ver Documento - Designación"
                        data-toggle="tooltip"
                        data-placement="top"
                        title="Ver Documento - Designación"
                        style={{ width: 24, height: 24 }} // Ajusta el tamaño según necesites
                    />
                </i>
            </span>
            :
            <></>
    )

    const iconoVerDocumento = (
        data.acciones.refarchivo ?
        <span style={{ cursor: 'pointer' }}>
            <i
                data-toggle="tooltip" data-placement="top" title="Ver Documento - Solicitud"
                onClick={() => onClickVerDocumento(data.acciones.refarchivo)}
            >
                <img
                    src={PdfSVG}
                    className="acciones"
                    alt="Ver Documento - Solicitud"
                    data-toggle="tooltip"
                    data-placement="top"
                        title="Ver Documento - Solicitud"
                    style={{ width: 24, height: 24 }} // Ajusta el tamaño según necesites
                />
            </i>
        </span>
            :
            <></>
    )

    const contentAccion = (
        <React.Fragment>
            {iconoVerDocumentoAutoridad} {iconoVerDocumento}
        </React.Fragment>
    )
    return contentAccion
}

  const filas = useMemo(
    () => [...dataFilas], [dataFilas]
  )

  const columnas: any = React.useMemo(
    () => [
      {
        Header: 'Fecha Solicitud',
        accessor: 'fechasolicitud',
        Cell: ({ value }) => value !== undefined ? ObtenerFechaFromIsoFormat(value) : undefined
      },
      {
        Header: 'Número de Solicitud',
        accessor: 'nroformulario'
      },
      {
        Header: 'Solicitado por',
        accessor: 'nombreunidad'
      },
      {
        Header: 'Asignado por',
        accessor: 'nombreunidadautoridad'
      },
      {
        Header: 'Nombre Proyecto',
        accessor: 'nombreproyecto'
      },
      {
        Header: 'Nombre Catálogo',
        accessor: 'nombreproyectocatalogo'
      },
      {
        Header: 'Ámbito',
        accessor: 'ambito'
      },
      {
        Header: 'Identificación',
        accessor: 'identificacion'
      },
      {
        Header: 'Nombres',
        accessor: 'nombres'
      },
      {
        Header: 'Cargo',
        accessor: 'cargo'
      },
      {
        Header: 'Término',
        accessor: 'termino'
      },
      {
        Header: 'Fecha desde',
        accessor: 'fechadesde',
        Cell: ({ value }) => value !== undefined ? ObtenerFechaFromIsoFormat(value) : undefined
      },
      {
        Header: 'Fecha hasta',
        accessor: 'fechahasta',
        Cell: ({ value }) => value !== undefined ? ObtenerFechaFromIsoFormat(value) : undefined
      },
      {
        Header: 'Horas semanales',
        accessor: 'horassemanales'
      },
      {
        Header: 'Horas anuales',
        accessor: 'horasanuales'
      },
      {
        Header: 'Estado',
        accessor: 'nestado'
      },
      {
          Header: "Acciones",
          accessor: (row) => ({
              acciones: row,
          }),
          Cell: ({ value }) => GenerarCellAcciones(value)
      },

    ], [dataFilas]
  )

    const columnasStyles = (cell): Array<CustomStyleColumn> => [
    {
      HeaderName: 'Identificación',
      StyleHeader: {
        textAlign: "center"
      }
    },
    {
      HeaderName: 'Acciones',
      StyleHeader: {
        textAlign: "center"
      }
    },
  ]

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    nextPage,
    previousPage,
    canNextPage,
    canPreviousPage,
    pageOptions,
    setPageSize,
    visibleColumns,
    prepareRow,
    state,
    setGlobalFilter
  } = useTable(
    {
      columns: columnas,
      data: filas
    },
    useGlobalFilter,
    useSortBy,
    usePagination
  )

  const { globalFilter, pageIndex, pageSize } = state;
  const sizerows = filas.length;


  function HandleChangeAnioOnTable(anioSeleccionado) {
    if (typeof (anioSeleccionado) === "number") {
      setanioMostrado(anioSeleccionado.toString())
    }
    onChangeAnio(anioSeleccionado)
  }

  const BotonDescargarReporte = useMemo(() => {

      const URLAnios = "ProyectosInstitucionales/HistorialSolicitudesConsultor/AniosDisponibles";

      const URLREPORTE = "ProyectosInstitucionales/HistorialSolicitudesConsultor/Reporte"

    if (anioSeleccionado !== undefined) {

      const anioForButton = +anioSeleccionado

      return (
        <ButtonDownloadReportTable
          api={URLREPORTE}
          nombreBoton='Reporte Historial'
          apiYears={URLAnios}
          onChangeYearNotAsync={HandleChangeAnioOnTable}
          yearElegido={anioForButton}
        />
      )
    }

  }, [anioSeleccionado])


  return (
    <React.Fragment>
      <Row>
        <Col xl={12}>
          <div className="containerBtnAprobacionesVacLic">
              <GlobalFilterTable
                  filter={globalFilter}
                  setFilter={setGlobalFilter}
              />
              
          </div>
        </Col>
      </Row>
      <Row className="justify-content-end mb-1">
        <Col xl={3} lg={3} md={4} sm={12}>
          {BotonDescargarReporte}
        </Col>
      </Row>
      <Row>
        <Col xl={12}>
          <Table responsive {...getTableProps()} style={{ border: 'solid 1px ' }} className="tablesReact" >
            <thead style={{}}>
              {headerGroups.map(headerGroup => (
                <tr {...headerGroup.getHeaderGroupProps()}>
                  {headerGroup.headers.map(column => (
                    <th
                      {...column.getHeaderProps(column.getSortByToggleProps())}
                      className='clickable'
                    >
                      {column.render('Header')}
                      <span>
                        {column.isSorted ? (column.isSortedDesc ? '⬆️' : '⬇️') : ''}
                      </span>
                    </th>
                  ))}
                </tr>
              ))}
            </thead>
            <tbody {...getTableBodyProps()}>
              {page.map((row, indirow) => {
                prepareRow(row)
                return (
                  <tr {...row.getRowProps()}>

                    {row.cells.map(cell => {
                        return getTdTableStyles(cell, { border: 'solid 1px black' }, indirow, columnasStyles(cell))

                    })}
                  </tr>
                )
              })}
            </tbody>
          </Table>
          <ComponentePaginacionTabla
            page={page}
            sizerows={sizerows}
            canNextPage={canNextPage}
            canPreviousPage={canPreviousPage}
            nextPage={nextPage}
            pageIndex={pageIndex}
            pageOptions={pageOptions}
            pageSize={pageSize}
            previousPage={previousPage}
            setPageSize={setPageSize}

          />
        </Col>
      </Row>

    </React.Fragment>
  )
}